import React, { Component, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { formatMoney } from '@shopify/theme-currency';
import { getSizedImageUrl } from '@shopify/theme-images';
import { useCartUpdate } from '@src/hooks';
import { render } from 'react-dom';

const CartLineItem = ({ product }) => {
  const queryClient = useQueryClient();
  const ctx = window.theme_app;
  const [quantity, setQuantity] = useState();
  const updateCart = useCartUpdate();

  useEffect(() => {
    setQuantity(product.quantity);
  }, [product.quantity]);

  const handleCartRemoval = () => {
    const { systemCart } = window.theme_app.getState();
    var removeIds = [];
    removeIds.push(product.variant_id);
    let payload = {};
    removeIds.forEach((element) => (payload[element] = 0));
    // let payload = removeIds.map((item) => ({ id: item, quantity: 0 }));
    updateCart.mutateAsync({ updates: payload }).then((response) => ctx.emit('cart.update', response.data));
  };

  const handleQuantityUpdate = (newQuantity) => {
    updateCart.mutateAsync({ updates: { [product.variant_id]: newQuantity } }).then((response) => {
      ctx.emit('cart.update', response.data);
      queryClient.invalidateQueries('cart');
    });
  };

  // let measurementAttrs = ['Width', 'Height', 'Length'];
  // let storedUnit = product.properties ? product.properties['_userUnit'] || 'imperial' : null;

  let renderProductPrice = (item) => {
    if (item.original_line_price !== item.final_line_price) {
      return (
        <div className="discounted-price">
          <span className="previous">{formatMoney(item.original_line_price)}</span>
          <span className="newPrice">{formatMoney(item.final_line_price)}</span>
        </div>
      );
    }
    return formatMoney(item.price);
  };

  const renderProductImage = (product) => {
    if (product.properties_all?._customization) {
      return <img src={'/apps/zakeke/preview/' + product.properties_all._customization} alt={product.title} loading="lazy" />;
    }
    if (product.properties_all?._preview) {
      return <img src={product.properties_all._preview} alt={product.title} loading="lazy" />;
    }
    return <img src={getSizedImageUrl(product.image, '200x')} alt={product.product_title} />;
  };

  return (
    <div className="Card Card--cartItem">
      <figure className="Card__media" data-layout="image-contain">
        {(product.image || product.properties_all?._customization || product.properties_all?._preview) && (
          <a href={product.url}>{renderProductImage(product)}</a>
        )}
      </figure>
      <div className="Card__content">
        <h6 className="Card__title">
          <a href={product.url}>{product.product_title}</a>
        </h6>
        {product.options_with_values?.length > 0 && (
          <div className="Card__meta">
            <dl className="product-attributes">
              {product.options_with_values.map((item) => {
                if (item.value != 'Default Title' && item.name != 'Title') {
                  return (
                    <div key={item.name}>
                      <dt>{item.name}:</dt>
                      <dd>{item.value}</dd>
                    </div>
                  );
                }
              })}
            </dl>
            <dl className="product-attributes">
              {product.properties &&
                Object.keys(product.properties).map((item) => {
                  if (item.charAt(0) != '_' && item != 'Preview') {
                    return (
                      <div key={item}>
                        <dt>{item}:</dt>
                        <dd>{product.properties[item]}</dd>
                      </div>
                    );
                  }
                })}
            </dl>
          </div>
        )}
        <div className="quantity_and_amount">
          <div className="line-item-options">
            {product.final_price === 0 ? (
              <div className="qty-input">
                {/* <span className="multiplier">x</span> */}
                <span className="quantity">{quantity}</span>
              </div>
            ) : (
              <div className="qty-input">
                {/* <span className="multiplier">x</span> */}
                <div className="qty-input-selector">
                  <button
                    type="button"
                    className="Button"
                    data-style="noLayout"
                    onClick={() => handleQuantityUpdate(quantity - 1)}
                    aria-label="minus"
                  >
                    <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                      <use href="#minus"></use>
                    </svg>
                  </button>
                  <span className="quantity">{quantity}</span>
                  <button
                    type="button"
                    className="Button"
                    data-style="noLayout"
                    onClick={() => handleQuantityUpdate(quantity + 1)}
                    aria-label="plus"
                  >
                    <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                      <use href="#plus"></use>
                    </svg>
                  </button>
                </div>
              </div>
            )}
            <button className="Button delete-line" data-style="text" data-layout="noLayout" onClick={handleCartRemoval} aria-label="Remove">
              <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                <use href="#trash"></use>
              </svg>
            </button>
          </div>
          <div className="amount">{renderProductPrice(product)}</div>
        </div>
      </div>
    </div>
  );
};

export default CartLineItem;
